import axios from "axios";

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

// add proxy
api.interceptors.request.use((config) => {

  let proxy = localStorage.getItem('proxy_user');
  if (proxy) {
    proxy = JSON.parse(proxy);
    config.params = { ...config.params, proxy: proxy.userId };
  }

  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    let msg = error.message;
    if (error.response?.data && error.response.data.message) {
      msg = error.response.data.message;
      if (typeof msg === "string") {
        error.message = msg;
      } else {
        if (Array.isArray(msg)) {
          error.message = msg.join("\n");
        }
      }
    }
    throw error;
  }
);

export const signIn = async (username, password) => {
  const response = await api.post("/auth/login", { username, password });
  const { accessToken, refreshToken, user } = response.data;
  setAuthData(accessToken, refreshToken);
  return { user };
  // return {username, password}
};

export const signUp = async (req) => {
  try {
    const response = await api.post("/register", req, {});
    const { user, accessToken, refreshToken } = response.data;
    setAuthData(accessToken, refreshToken);
    return { user };
  } catch (e) {
    if (e.response) {
      let msg = e.response.data;
      return msg;
    }
    throw e;
  }
};

export const signOut = async (username, password) => {
  clearAuthData();
};

export const confirmPasswordReset = async (data) => {
  try {
    const response = await api.post("/auth/reset-password", data);
    return response.data;
  } catch (e) {
    if (e.response) {
      let msg = e.response.data;
      return msg;
    }
    throw e;
  }
};
export const sendPasswordResetEmail = async (email) => {
  try {
    const response = await api.post("/auth/forgot-password", { email });
    return response.data;
  } catch (e) {
    if (e.response) {
      let msg = e.response.data;
      return msg;
    }
    throw e;
  }
};

function clearAuthData() {
  console.log("clear token");
  delete api.defaults.headers.common["Authorization"];
  if (!localStorage) {
    return false;
  }
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  return true;
}

export function setAuthData(accessToken, refreshToken, user) {
  api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
  if (!localStorage) {
    return false;
  }
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  return true;
}

function getAuthData() {
  const accessToken = localStorage.getItem("accessToken");
  api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
}

getAuthData();
